import React, { useState } from 'react';

import CareerStageForm from './CareerStageForm';
import JobInfoForm from './JobInfoForm';

const JobForm = ({ closeHandler, refetchHandler, toast, type = 'account', hasName = false }) => {
    const [subStep, setSubStep] = useState(1);

    if (subStep === 1) {
        return (
            <CareerStageForm
                type={type}
                hasName={hasName}
                toast={toast}
                onBack={closeHandler}
                onNext={() => setSubStep(2)}
            />
        );
    }

    return (
        <JobInfoForm
            type={type}
            toast={toast}
            closeHandler={closeHandler}
            refetchHandler={refetchHandler}
            onBack={() => setSubStep(1)}
        />
    );
};

export default JobForm;
